/** Shared with {@link GlobalAuthService} so logout forces the next shell to reload ngx-permissions. */
let lastNavPermissionJson: string | null = null;

export function getLastNavPermissionJson(): string | null {
  return lastNavPermissionJson;
}

export function setLastNavPermissionJson(json: string | null): void {
  lastNavPermissionJson = json;
}

export function resetNavPermissionSync(): void {
  lastNavPermissionJson = null;
}
